module.exports = __webpack_public_path__ + "img/ic_kakao_channel.dee35b4.png";